import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AnalyticsLayout from '../components/analytics/AnalyticsLayout';
import TokenScorecard from '../components/analytics/TokenScorecard';
import MarketMakerPerformance from '../components/analytics/MarketMakerPerformance';
import ExchangeBenchmarking from '../components/analytics/ExchangeBenchmarking';
import SimulationStrategy from '../components/analytics/SimulationStrategy';

const AnalyticsPage = () => {
  return (
    <AnalyticsLayout>
      <Routes>
        <Route index element={<TokenScorecard />} />
        <Route path="/" element={<Navigate to="/analytics/token-scorecard" replace />} />
        <Route path="/token-scorecard" element={<TokenScorecard />} />
        <Route path="/market-makers" element={<MarketMakerPerformance />} />
        <Route path="/exchanges" element={<ExchangeBenchmarking />} />
        <Route path="/simulation" element={<SimulationStrategy />} />
      </Routes>
    </AnalyticsLayout>
  );
};

export default AnalyticsPage;